import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper scroll-wrapper form-limited" }
const _hoisted_2 = { class: "input-row" }
const _hoisted_3 = { class: "input-wr w-100" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    showClose: true,
    onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.close())),
    classes: "decline-refund-model height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "modal__title" }, "Mark as non-refundable", -1)),
        _createElementVNode("form", {
          class: "default-form form-group",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "Specify decline reason (optional)", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "textarea",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.comment) = $event)),
                placeholder: "Add the reason here..."
              }, null, 512), [
                [_vModelText, $setup.form.comment]
              ])
            ])
          ])
        ], 32),
        _createElementVNode("div", {
          class: _normalizeClass(["controls", { 'disabled-block ': $setup.disabled }])
        }, [
          _createElementVNode("button", {
            class: "button default cancel",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.close())),
            disabled: $setup.disabled
          }, "Cancel", 8, _hoisted_4),
          _createElementVNode("button", {
            class: "button default primary save",
            onClick: $setup.save,
            disabled: $setup.disabled
          }, "Confirm", 8, _hoisted_5)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}